var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-large":"","color":"success","loading":!_vm.paymentCheckout},on:{"click":function($event){return _vm.pagar()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-credit-card-outline")]),_vm._v(" Pagar con Tarjeta ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }